export default {
  title: 'Tools of HKLII',
  predictor: 'HKU AI Lawyer — Sentencing Predictor for Drug Trafficking',
  predictor_desc: 'Calculate the likely sentencing for drug trafficking charges referencing over 3,000 cases',
  sqe: 'Case Analytics',
  sqe_desc: 'Get staticstics and data visualizations of PI and drug trafficking cases',
  summary: 'Case Summary', // change to case highlight?
  summary_desc: 'Quickly grasp different aspects of PI judgments by getting key paragraphs highlighted',
  tag_stats: '#Statistics',
  tag_summary: '#Summary',
  tag_pi: '#Personal Injury',
  tag_dt: '#Drug Trafficking',
  tag_sentence: '#Sentencing',
}